import React, { Component } from 'react';
import Navbar from './Navbar';

export default class Header extends Component{
    
    render(props){
        return(
            <div>
                <Navbar
                 home={this.props.homeActive} 
                 service={this.props.serviceActive} 
                 products={this.props.productsActive} 
                 gallery={this.props.galleryActive} 
                 about={this.props.aboutActive} 
                 localization={this.props.localizationActive} 
                 contactos={this.props.contactosActive} 
                />
            </div>
        );
    }
}